export default {
  masters: ({ masters }) => masters,
  formInput: ({ formInput }) => formInput,
}
